import { GET_OUT_OF_STOCK_LIST, GET_OUT_OF_STOCK_LISTS, UPDATE_OUT_OF_STOCK_LIST } from '../constants/action-types';

// INITIALIZE STATE
const initialState = {
    currentOutOfStockList: []
};

// REDUCER
export const OutOfStockReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_OUT_OF_STOCK_LIST: {
            const currentOutOfStockList = action.payload;

            return {
                ...state,
                currentOutOfStockList
            }
        }

        case UPDATE_OUT_OF_STOCK_LIST: {
            return {
                ...state,
            }
        }

        default:
            return state;
    }
};